import { loadPage } from "loader-lib";
import Datalist from "../components/common/Datalist";
import Spacer from "../components/ui/Spacer";
import { useContent } from "../context/ContentContext";
import { getApplicationList } from "../stores/applications";

const cols = [
  {
    name: "trackno",
    title: "Tracking No.",
    width: 150,
  },
  {
    name: "type",
    title: "Type",
    width: 100,
  },
  {
    name: "particulars",
    title: "Particulars",
  },
  {
    name: "applicant",
    title: "Applicant",
    width: 150,
  },
  {
    name: "dtsubmitted",
    title: "Date Submitted",
    width: 170,
  },
  {
    name: "elapsed",
    title: "Elapsed(days)",
    width: 100,
    alignment: "center",
  },
];

interface AttrProps {
  tag: string;
  title: string;
}

interface OnlineTxnListPage {
  attr: AttrProps;
  id: string;
  target: string;
}

const OnlineTxnListPage = (props: OnlineTxnListPage) => {
  const { tag, title } = props.attr;
  const { id, target } = props;
  const { setContent } = useContent();

  const listHandler = async (params: Record<string, any>) => {
    const data = await getApplicationList({
      ...params,
      tag,
      limit: params.limit ?? 10,
    });
    return data;
  };

  const openItem = async (item: Record<string, any>) => {
    const type = item.type.toLowerCase();
    const page = `online_page_${type}`;

    const templ = await loadPage({
      page: page,
      target: target,
      params: { itemid: item.trackno, prevPage: id },
    });
    setContent(target, () => templ);
  };

  return (
    <div className="flex flex-col p-4">
      <p className="text-3xl font-bold">{title}</p>
      <Spacer />
      <Datalist
        cols={cols}
        handler={listHandler}
        limit={10}
        openItem={openItem}
        searchFields={["trackno", "type"]}
        emptyState={{
          title: "No Record Yet",
          message: `To see results, enter a keyword or phrase in the search bar as tracking number to find what you&apos;re
            looking for`,
        }}
        allowSearch
      />
    </div>
  );
};

export default OnlineTxnListPage;
